import { web_basic_api } from './web.jsy'
import { web_stream_api } from './web_stream.jsy'
import { websocket_api } from './ws_stream.jsy'

export default web_full_plugin
export function web_full_plugin(plugin_options={}) ::
  // websocket extends basic, and is thus the superset
  return hub => ::
    hub.registerProtocols @ ['ws', 'ws:', 'wss', 'wss:'],
      url => hub.web.connectWS(url, true)

    hub.web = @{} __proto__: @{}
      ... web_basic_api(hub, plugin_options),
      ... web_stream_api(hub, plugin_options),
      ... websocket_api(hub, plugin_options),

